var map = {
	"./bg-glow.svg": 65,
	"./bg-s-shape.svg": 66,
	"./svg-sprite/icon-calendar.svg": 67,
	"./svg-sprite/icon-checkmark.svg": 68,
	"./svg-sprite/icon-email.svg": 69,
	"./svg-sprite/icon-long-arrow.svg": 70,
	"./svg-sprite/icon-minus.svg": 71,
	"./svg-sprite/icon-paper-plane.svg": 72,
	"./svg-sprite/icon-plus.svg": 73,
	"./svg-sprite/icon-pointer-arrow.svg": 74,
	"./svg-sprite/icon-scroll-down.svg": 75,
	"./svg-sprite/icon-video.svg": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;